export { default as ScoutListConfiguration } from './ScoutListConfiguration';
export { default as FreshFacesConfiguration } from './FreshFacesConfiguration';
export { default as ReferralsConfiguration } from './ReferralsConfiguration';
export { default as PatientJourneyConfiguration } from './PatientJourneyConfiguration';
export { default as NotReferringConfiguration } from './NotReferringConfiguration';
export { default as TreatingVolumeConfiguration } from './TreatingVolumeConfiguration';
